<template>
  <div id="send-material-by-email">
    <el-dialog title="" v-model="mailModalShow" size="tiny" custom-class="mail-modal" @close="close" :show-close="false" top="50%">
      <span class="mail-header" slot="title">
        <div class="title">发送资料至邮箱</div>
        <div class="header-close" @click="close">
          <i class="el-icon-close" />
        </div>
      </span>
      <div class="mail-content">
        <div class="mail-item">
          <div class="mail-item-label">资料递交方式</div>
          <div class="mail-item-content">
            <el-radio class="radio" v-model="materialType" :label="0">在线上传资料</el-radio>
            <el-radio :disabled="!this.product.offline" class="radio" v-model="materialType" :label="1">线下邮寄资料</el-radio>
          </div>
        </div>
        <div class="mail-item identity">
          <div class="mail-item-label">顾客身份</div>
          <div class="mail-item-content">
            <div class="identity-list">
              <div class="identity-item"
                :class="{active: selectIdentity.indexOf(item) > -1}"
                v-for="item in currIdentitys"
                :key="item"
                @click="handleSelectIdentity(item)"
              >{{identities[item]}}</div>
            </div>
          </div>
        </div>
        <div class="mail-item ">
          <div class="mail-item-label">邮箱地址</div>
          <div class="mail-item-content not-hidden">
            <el-input size="large" placeholder="请输入邮箱地址" :maxlength="50" v-model="email" @input="emailError=''"></el-input>
            <div class="el-form-item__error" v-if="emailError" >请输入正确的邮箱地址</div>
          </div>
        </div>


      </div>
      <div class="mail-footer">
        <div class="tips">请留意来自service@666visa.cn的邮件</div>
        <el-button type="primary" size="large" class="mail-dialog-btn" :disabled="!selectIdentity.length" @click="mailSubmit" :loading="emailLoading">发送</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import validates from '@/libs/validates';
import Http from '../../../../libs/http';
import User from '../../../../libs/user';
import utils from '../../../../libs/utils';

export default {
  name: 'send-material-by-email',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    value: {
      type: Boolean,
      required: true,
      default: false,
    },

    isOffline: {
      type: [Boolean, Number],
      default: false,
    },

    identitySelectedId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      mailModalShow: this.value, // 是否展示
      materialType: 0,
      email: '',
      emailError: '',
      emailLoading: false,
      identities: ['在职人员', '自由职业者', '退休人员', '在校学生', '学龄前儿童', '通用身份'],
      selectIdentity: [],
    };
  },
  computed: {
    // 当前支持的身份id
    currIdentitys() {
      const list = [];
      // 筛选是否是线下
      const allMaterialList = this.materialType ? this.product.offline_material : this.product.material;
      allMaterialList.forEach((item) => {
        list.push(item.identity_id);
      });
      return list;
    },
  },
  watch: {
    value(newVal) {
      this.mailModalShow = newVal;
      if (newVal) {
        // 弹窗显示,初始化赋值
        this.materialType = this.isOffline ? 1 : 0;
        this.$nextTick(() => {
          this.selectIdentity = [this.identitySelectedId];
        });

      }
    },
    materialType() {
      // 切换了在线离线，得把选择清空，默认选择第一个
      this.selectIdentity = [this.currIdentitys[0]];
    },
  },
  created() {
  },
  methods: {

    // 关闭
    close() {
      this.email = '';
      this.mailModalShow = false;
      this.emailError = false;
      this.emailLoading = false;
      this.$emit('input', false);
    },

    // 是否是通用商品
    isUniversalIdentity() {
      if (this.product && this.product.material && this.product.material[0]) {
        return this.product.material[0].identity_id === 5;
      }
      return false;
    },


    mailSubmit() {
      const { emailReg } = validates.inputRegexpCollection;
      if (!emailReg.test(this.email)) {
        return (this.emailError = true);
      }

      this.emailError = false;

      this.emailLoading = true;
      const requestList = [];
      this.selectIdentity.forEach((identityId) => {
        requestList.push(Http.post('/visa_product_email_send', {
          visa_product_id: +this.product.visa_product_id,
          identity_id: identityId,
          email: this.email,
          peer_account_id: User.peer_account_id,
          offline: this.materialType,
        }));
      });
      Promise.all(requestList).then(() => {
        utils.msg.success('发送成功');
        this.emailLoading = false;
        this.mailModalShow = false;
      }).catch(() => {
        this.emailLoading = false;
      });

    },
    handleSelectIdentity(id) {
      const index = this.selectIdentity.indexOf(id);
      if (index > -1) {
        this.selectIdentity.splice(index, 1);
      } else {
        this.selectIdentity.push(id);
      }
    },
  },

};
</script>

<style lang="less" scoped>
#send-material-by-email {
  display: flex;
  /deep/ .mail-modal{
    width: 600px;
    transform: translate(-50%, -50%);
    .el-dialog__header{
      padding: 0;
      .mail-header{
        height: 60px;
        padding: 0 24px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #E9EEF2;
        .title{
          flex-grow: 1;
          font-size: 20px;
          color: #2F333D;
          font-weight: 600;
        }
        .header-close{
          color: #91999F;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
    .el-dialog__body{
      padding: 0px;
      .mail-content{
        padding: 24px;
        .mail-item{
          display: flex;
          align-items: center;
          margin-bottom: 24px;
          &:last-child{
            margin-bottom: 0;
          }
          &.identity{
            .mail-item-label{
              align-self: flex-start;
              line-height: 40px;
            }
          }
          .mail-item-label{
            width: 100px;
            flex-grow: 0;
            font-size: 16px;
            color:#2F333D;
            font-weight: 600;
            margin-right: 20px;
            text-align: right;
            flex-shrink: 0;
          }
          .mail-item-content{
            flex-grow: 1;
            overflow: hidden;
            position: relative;
            color:#2C3344;
            &.not-hidden{
              overflow: visible;
            }
            .el-radio{
              display: inline-flex;
              align-items: center;
              .el-radio__input{
                font-size: 0;
              }
            }
            .el-radio__label{
              padding-left: 4px;
              color:#2C3344;
            }
            .el-radio + .el-radio{
              margin-left: 30px;
            }
            .el-input--large .el-input__inner{
              height: 40px;
              font-size: 14px;
            }
            .identity-list{
              display: flex;
              flex-wrap: wrap;
              margin-right: -12px;
              margin-bottom: -12px;
              .identity-item{
                width: 118px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius:2px;
                border:1px solid #DEE2E6;
                font-size: 14px;
                color: #91999F;
                line-height: 1;
                margin-right: 12px;
                margin-bottom: 12px;
                position: relative;
                cursor: pointer;
                &.active{
                  border: 1px solid #599FFF;
                  color: #599FFF;
                  &::after{
                    content: "";
                    width: 24px;
                    height: 24px;
                    position: absolute;
                    right: -1px;
                    bottom: -1px;
                    background: url(../../../../assets/imgs/product-detail/icon-identity-select.png) no-repeat center / 100% 100%;
                  }
                }
              }
            }
          }
        }
        .mail-dialog-btn{
          width: 100%;
          font-size: 14px;
          padding: 12px 19px;
        }
      }
      .mail-footer{
        border-top: 1px solid #E9EEF2;
        display: flex;
        align-items: center;
        height: 80px;
        padding: 24px;
        .tips{
          flex-grow: 1;
          color: #91999F;
          font-size: 14px;
        }
        .mail-dialog-btn{
          flex-shrink: 0;
          width: 196px;
          height: 48px;
          border-radius:4px;
          background-color: #599FFF;
          font-size: 18px;
          &.is-disabled{
            background: #BCD8FF;
            border: 1px solid #BCD8FF;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/send-material-by-email.vue